<template>
<div class="solution-card card" @click="$emit('goSolution')">
  <div class="info">
  <div v-html="info.name" class="title"></div>
  <div class="tags">
    <div v-for="(el,i) in tagList" :key="i" v-html="el"></div>
  </div>
  </div>
  <div  class="text-overflow2 text" v-html="info.solutionDiscription"></div>
</div>
</template>

<script>
export default{
  props: ["info"],
  data(){
    return{}
  },
  computed:{
    tagList(){
      if(this.info.tag){
        return this.info.tag?.split(',')
      }else {
        return []
      }
    }
  }
}
</script>


<style scoped lang="scss">
.solution-card{
  padding: 24px;
  border-bottom: 1px solid #EEEEEE;
  height: 166px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  >.info{
    >.title{
      font-weight: 400;
      font-size: 16px;
      color: #262626;
      line-height: 22px;
      margin-bottom: 12px;
    }
    >.tags{
      display: flex;
      flex-wrap: wrap;
      max-height: 64px;
      overflow-y: hidden;
      >div{
        padding: 4px 8px;
        background: #F5F5F5;
        font-weight: 400;
        font-size: 12px;
        color: #262626;
        line-height: 16px;
        margin-right: 12px;
        margin-bottom: 8px;
      }
    }
  }

  >.text{
    font-weight: 400;
    font-size: 14px;
    color: #666666;
    line-height: 20px;
  }
}
</style>
